module.exports = __webpack_public_path__ + "img/earth_15-wallpaper-1440x900.e286bd1d.jpg";